import { signInWithPopup } from "firebase/auth"
import { toast } from "react-toastify"
import { auth, provider } from "../firebase"

// Cancel Subscription function
let server = process.env.REACT_APP_SERVER //'http://localhost:8000'

const cancelUtility = async (userData) => {
    console.log('cancel')
    let confirm = window.confirm('Are you sure you want to cancel')
    if (confirm) {
        const data = await fetch(server + '/cancel', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                customerId: userData.customerId,
                email: userData.email,
                baserowId: userData.baserowId
            })
        }).then(res => res.json())
        return data
    }

}

// notify function

const notify = (state, msg) => {
    console.log(state)
    return toast[state](msg)
}

const login = async (user) => {
    if (user) {
        fetch(server + '/user/' + user.email, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(res => res.json()).then(data => {
            if (data.isSubscribed && data.generatedLink !== "") {
                window.location.href = '/profile'
            } else if (data.isSubscribed && data.generatedLink === "") {
                window.location.href = '/youtube'
            } else {
                window.location.href = '/pricing'

            }
        })
    } else {
        await signInWithPopup(auth, provider).then(({ user }) => {
            fetch(server + '/login', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: user.email,
                    userName: user.displayName
                })
            }).then(res => res.json()).then(data => {
                // if (data.isSubscribed === false) {
                //     window.location.href = '/pricing'
                // } else {
                //     console.log('subscribed')
                // }
                window.location.href = data.redirect
                console.log(data)
            })
        })
    }

}

export { cancelUtility, notify, login }